import { Component } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';

// tslint:disable:nx-enforce-module-boundaries
import {
    AuthService,
    UserCredentials,
} from '@elight/client/shared/utility/auth';
import { AbstractBaseComponent } from '@elight/client/shared/utility/common';
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordDialogComponent } from './reset-password-dialog.component';
import { LocalStorageService } from '@elight/client/shared/utility/storage';
// tslint:enable:nx-enforce-module-boundaries

@Component({
    selector: 'elight-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent extends AbstractBaseComponent {
    public loginForm: FormGroup;
    public hasError = false;

    constructor(
        fb: FormBuilder,
        private authService: AuthService,
        private router: Router,
        private dialog: MatDialog,
        private storage: LocalStorageService
    ) {
        super();

        this.storage.clear();
        this.authService.currentUser$.pipe(take(1)).subscribe((user) => {
            if (user) {
                this.router.navigate(['projects']);
            }
        });

        this.loginForm = fb.group({
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required]),
        });
    }

    public onLoginFormSubmit() {
        if (this.loginForm.valid) {
            const credentials: UserCredentials = this.loginForm.value;
            this.hasError = false;

            this.authService.login(credentials).subscribe(
                () => {
                    this.router.navigate(['projects']);
                },
                () => {
                    this.hasError = true;
                }
            );
        }
    }

    openResetPasswordDialog(): void {
        this.dialog.open(ResetPasswordDialogComponent);
    }
}
